
import { gql } from 'apollo-boost';

export const MUTATION_PROCESS_INSURANCE_QUOTE_ON_OCA_SUBMISSION = gql`
  mutation ProcessInsuranceQuoteOnOcaSubmission($creditApplicationId: ID!, $accountId: ID!) {
    insuranceQuote {
      processInsuranceQuoteOnOcaSubmission(creditApplicationId: $creditApplicationId, accountId: $accountId) {
        error
        success
        taskId
        insuranceQuoteId
        redirectUrl
      }
    }
  }
`;
